export const processSuggestions = (suggestions = []) => {
    return suggestions.map((suggestion) => {
        const [ , _id, , , , , teamId, active, name ,slug] = suggestion.split('|');
        const id = parseInt(_id, 10);
        return {
                id,
                name,
                teamId,
                isActivePlayer: active === '1',
                url: `https://www.mlb.com/player/${slug}`
            };
    });
}

export async function fetchSuggestions(query) {
    try {
        const response = await fetch(`https://suggest.mlb.com/svc/suggest/v1/min_all/${query}/99999`);
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const results = await response.json();
        return processSuggestions(results.suggestions);
    } catch (err) {
        return [];
    }
}